// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2K7tX","consentsList":"PatientConsents_consentsList__3-4KO","consentsListEmpty":"PatientConsents_consentsListEmpty__LSjoZ"};